"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainRegistryInterface__factory = exports.DomainRegistry__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var DomainRegistry__factory_1 = require("./DomainRegistry__factory");
Object.defineProperty(exports, "DomainRegistry__factory", { enumerable: true, get: function () { return DomainRegistry__factory_1.DomainRegistry__factory; } });
var DomainRegistryInterface__factory_1 = require("./DomainRegistryInterface__factory");
Object.defineProperty(exports, "DomainRegistryInterface__factory", { enumerable: true, get: function () { return DomainRegistryInterface__factory_1.DomainRegistryInterface__factory; } });
//# sourceMappingURL=index.js.map